t = require('views/internal/teacup-with-helpers')('popover_auto_mentioner')

module.exports = ->
  t.mustacheBlock 'button', ->
    t.input '.js-filter-mentionables.js-autofocus', { type: 'text', placeholder: t.l('search-members-ellipsis') }

  t.p '.quiet.js-empty-list.hide', { style: 'padding: 8px 8px 0;' }, ->
    t.format 'no-matching-members'

  t.ul '.pop-over-member-list.js-available-members'

  t.mustacheBlock 'button', ->
    t.div '.js-select-multiple-options.hide', ->
      t.hr()

      t.ul '.pop-over-list', ->
        t.mustacheBlock 'showAllCardMembers', ->
          t.li ->
            t.a '.js-select-all-card-members', { href: '#' }, ->
              t.format 'mention-all-card-members'
        t.mustacheBlock 'showAllBoardMembers', ->
          t.li ->
            t.a '.js-select-all-board-members', { href: '#' }, ->
              t.format 'mention-all-board-members'
        t.mustacheBlock 'showAllCommenters', ->
          t.li ->
            t.a '.js-select-all-commenters', { href: '#' }, ->
              t.format 'mention-all-commenters'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_auto_mentioner.coffee